import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "merchant_task_drawer",
  class: "bg-body",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "explore",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'400px', 'lg': '475px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#merchant_task_drawer_toggle",
  "data-kt-drawer-close": "#merchant_task_drawer_toggle"
}
const _hoisted_2 = { class: "card-body p-7 pt-4 shadow-none w-100" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title fs-5 pe-3 pb-10" })
], -1)
const _hoisted_5 = { class: "col text-end" }
const _hoisted_6 = { class: "card-title fs-5 pe-3 pb-10" }
const _hoisted_7 = { class: "pt-0 py-4 flex-row-fluid" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title fs-6 pe-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Pending")
const _hoisted_11 = { class: "ms-3 badge badge-light-primary" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "mb-1 fw-normal fs-7" }
const _hoisted_15 = { class: "col-md-auto" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill fs-2x text-danger" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill fs-2x text-success" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "pt-0 py-4 flex-row-fluid" }
const _hoisted_23 = { class: "card-header" }
const _hoisted_24 = { class: "card-title fs-6 pe-3" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Completed")
const _hoisted_26 = { class: "ms-3 badge badge-light-primary" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "fw-bolder" }
const _hoisted_30 = { class: "col-md-auto" }
const _hoisted_31 = {
  key: 0,
  type: "button",
  class: "position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square fs-2x text-white" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  type: "button",
  class: "position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-square fs-2x text-dark" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.merchantID), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.tasksPendingTotal), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasksPending, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["col-12 alert border border-primary p-2 mb-2", [item.status, item.color, item.text]])
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h5", _hoisted_14, _toDisplayString(item.name), 1),
                _createElementVNode("span", null, _toDisplayString(item.status), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: "position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto",
                  onClick: ($event: any) => (_ctx.onUpdateTask(item.id, 'Denied', 'bg-warning', 'text-dark'))
                }, _hoisted_18, 8, _hoisted_16),
                _createElementVNode("button", {
                  type: "button",
                  class: "position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto",
                  onClick: ($event: any) => (_ctx.onUpdateTask(item.id, 'Approved', 'bg-success', 'text-white'))
                }, _hoisted_21, 8, _hoisted_19)
              ])
            ])
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.tasksReviewedTotal), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasksReviewed, (item, index2) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index2,
            class: _normalizeClass(["col-12 alert border border-primary p-2 mb-2", [item.status, item.color, item.text]])
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("h5", {
                  class: _normalizeClass(["mb-1 fw-normal fs-7", [item.color, item.text]])
                }, _toDisplayString(item.name), 3),
                _createElementVNode("span", _hoisted_29, _toDisplayString(item.status), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", null, _toDisplayString(item.date_completed), 1),
                (item.status === 'Approved')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_31, _hoisted_33))
                  : _createCommentVNode("", true),
                (item.status === 'Denied')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_34, _hoisted_36))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}